import { APP_PERMISSIONS } from '@report/permission';

import { type AppMenuConfig } from '../../types';

export function useGetSidebarItem(): AppMenuConfig[] {
  return [
    {
      section: '',
      items: [
        {
          label: 'รายงานทั้งหมด',
          url: '/reports',
          iconName: 'REPORTS',
          permission: {
            requiredPermission: [
              APP_PERMISSIONS.EXAM_COURSE_ANALYSIS_REPORT.VIEW,
              APP_PERMISSIONS.EXAM_EVENT_OVERVIEW_REPORT.VIEW,
              APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_REPORT.VIEW,
              APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_YEARLY_REPORT.VIEW,
              APP_PERMISSIONS.QSET_USAGE_STATUS_REPORT.VIEW,
              APP_PERMISSIONS.QUESTION_USAGE_BY_QSET_REPORT.VIEW,
            ],
            operator: 'OR',
          },
        },
      ],
    },
  ];
}
